export interface IApplicationState {

    showBannerForReconstruction: boolean;


}

const initialState: IApplicationState = {
    showBannerForReconstruction: false,



};

export enum actionTypes {

    SHOW_BANNER_FOR_RECONSTRUCTION = '@@basegameReconstruction/SHOW_BANNER_FOR_RECONSTRUCTION',

}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { showBannerForReconstruction } = action;

    switch (action.type) {
        case actionTypes.SHOW_BANNER_FOR_RECONSTRUCTION:
            return {
                ...state, showBannerForReconstruction: showBannerForReconstruction,
            };

        default:
            return state;
    }
}

export const actions = {
    reconstructionBannerShow: (showBannerForReconstruction: boolean): any => ({
        type: actionTypes.SHOW_BANNER_FOR_RECONSTRUCTION,
        showBannerForReconstruction
    }),



};
